import { Injectable, signal } from '@angular/core';

/**
 * Open-state of the ONE search surface in the app: the global palette hosted
 * by `app-global-search` in the shell. Everything that used to open a search
 * (rail button, Cmd/Ctrl+K anywhere) goes through here, so there is exactly
 * one place to look for chats, agents, teams and messages.
 */
@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
  readonly open = signal(false);

  openPalette(): void {
    this.open.set(true);
  }

  close(): void {
    this.open.set(false);
  }

  toggle(): void {
    this.open.update((value) => !value);
  }
}
